import axios from '../lib/axios';

import { API_URL } from '../config';
import * as types from '../constants/ActionTypes';
import { fixExerciseStructure } from '../lib/exerciseTransformations/fixExerciseStructure';
import { handleUnauthorizedError } from '../lib/heartBeat';

export function getRelated(itemIds) {
    const url = `${API_URL}/related?relatedIds=${itemIds}`;
    return async dispatch => {
        dispatch({ type: types.FETCH_EXERCISES_BY_RELATED_FATHER });
        try {
            const { data } = await axios.get(`${url}`);
            dispatch({
                type: types.FETCH_EXERCISES_BY_RELATED_FATHER_SUCCESS,
                result: {
                    publicTitle: data.publicTitle,
                    relatedItems: data.relatedItems.map(fixExerciseStructure)
                }
            });
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            dispatch({
                type: types.FETCH_EXERCISES_BY_RELATED_FATHER_FAILURE,
                error: e
            });
        }
    };
}
